<template>
    <div class="gallery-box">
        <div v-if="visible && slides.length">
            <vue-agile
                v-if="visible"
                ref="main"
                :options="mainOptions"
                :as-nav-for="asNavFor1"
            >
                <div class="slide" v-for="(slide, index) in slides"
                     :key="index"
                     :class="`slide--${index} ${imageClass}`"
                     @click="setLightBoxIndex(index)"
                >
                    <b-img :src="slide" :alt="slide" class="img-fluid" itemprop="image" />
                </div>
            </vue-agile>
            <vue-agile
                v-if="visible && slides.length > 1"
                ref="thumbnails"
                class="mt-3"
                :options="thumbnailOptions"
                :as-nav-for="asNavFor2"
            >
                <div class="thumbnail-slide"
                     v-for="(slide, index) in slides"
                     :key="index"
                     :class="`slide--${index}`"
                     @click="$refs.thumbnails.goTo(index)"
                >
                    <b-img :src="slide" :alt="slide" class="img-fluid" />
                </div>
            </vue-agile>
            <CoolLightBox
                :items="slides"
                :index="lightBoxIndex"
                @close="lightBoxIndex = null">
            </CoolLightBox>
        </div>
        <div v-if="visible && !slides.length">
            <b-img fluid :src="getDefaultImage()" :alt="getAlt()" />
        </div>
        <div v-if="!visible">
            <div class="row">
                <div class="col-12"><b-skeleton width="100%" height="40vh"></b-skeleton></div>
            </div>
            <div class="row">
                <div class="col-3"><b-skeleton width="100%" height="15vh"></b-skeleton></div>
                <div class="col-3"><b-skeleton width="100%" height="15vh"></b-skeleton></div>
                <div class="col-3"><b-skeleton width="100%" height="15vh"></b-skeleton></div>
                <div class="col-3"><b-skeleton width="100%" height="15vh"></b-skeleton></div>
            </div>
        </div>
    </div>
</template>

<script>
import { VueAgile } from 'vue-agile'
import CoolLightBox from 'vue-cool-lightbox'
import { BImg, BSkeleton } from "bootstrap-vue";
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

export default {
    name: 'GalleryBox',
    components: {
        BImg, BSkeleton,
        VueAgile,
        CoolLightBox
    },
    props: {
        entry: null,
        isLoading: true
    },
    data () {
        return {
            lightBoxIndex: null,
            visible: false,
            asNavFor1: [],
            asNavFor2: [],
            slides: [],
            mainOptions: {
                dots: false,
                fade: false,
                navButtons: false
            },
            thumbnailOptions: {
                autoplay: false,
                centerMode: false,
                dots: false,
                infinite: true,
                navButtons: false,
                slidesToShow: 2,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 4
                        }
                    },
                ]
            },
        }
    },
    methods: {
      setLightBoxIndex(index){
          this.lightBoxIndex = index
      },
      getDefaultImage() {
        return this.$root.whitelabel.getDefaultImage()
      },
      getAlt() {
        return this.$t('image.alt.noimage')
      },
    },
    watch: {
        entry: function (val){
            let slides = []
            
            if(this.entry.images){
                let images = Object.values(this.entry.images)
                images.forEach((image) => {
                    slides.push(image.file_name);
                });

                this.slides = slides
                this.visible = true

                this.$nextTick(function() {
                    this.asNavFor2.push(this.$refs.main)
                    this.asNavFor1.push(this.$refs.thumbnails)
                });
            }
        }
    },
    computed: {
        imageClass(){
            return this.$root.whitelabel.setting('catalog_image_fit') ? 'object-fit-cover' : 'object-fit-contain'
        }
    }
}
</script>
